/* Lorelia · Social Proof (Paket E, 05.10.2026)
   1) Bewertungsreihe: wischbar (echtes Scrollen), Pfeile; mit data-lauf="1" ein langsames Laufband.
      Pausiert bei Maus darüber, Fokus, Berührung, eigenem Wischen, außerhalb des Bildschirms, im Hintergrund-Tab
      und per Pause-Knopf (WCAG 2.2.2). prefers-reduced-motion: kein Laufband, nur Wischen und Pfeile.
   2) Kundenfoto vergrößern: eigener <dialog>, Esc/Klick daneben schließt. */
(function () {
  'use strict';
  if (window.__lrSp) { window.__lrSp.alle(document); return; }
  var ruhig = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Reihe(el) {
    if (el.__lrSp) return; el.__lrSp = true;
    var fenster = el.querySelector('[data-lr-sp-fenster]');
    var spur = el.querySelector('[data-lr-sp-spur]');
    if (!fenster || !spur) return;
    var zurueck = el.querySelector('[data-lr-sp-zurueck]');
    var weiter = el.querySelector('[data-lr-sp-weiter]');
    var pause = el.querySelector('[data-lr-sp-pause]');
    var lauf = el.getAttribute('data-lauf') === '1' && !ruhig && spur.children.length > 2;
    var tempo = parseFloat(el.getAttribute('data-tempo')) || 18; /* px pro Sekunde */
    var gruende = {}; var raf = 0; var zuletzt = 0; var pos = 0; var gesetzt = 0; var halb = 0; var nutzerT = 0; var touchT = 0;

    function schritt() {
      var k = spur.children[0]; if (!k) return 300;
      var gap = parseFloat(getComputedStyle(spur).columnGap || getComputedStyle(spur).gap) || 14;
      return k.getBoundingClientRect().width + gap;
    }
    function blaettern(r) {
      fenster.scrollBy({ left: r * schritt(), behavior: ruhig ? 'auto' : 'smooth' });
      if (lauf) anhalten('nutzer', 7000);
    }
    if (zurueck) zurueck.addEventListener('click', function () { blaettern(-1); });
    if (weiter) weiter.addEventListener('click', function () { blaettern(1); });

    if (!lauf) {
      if (pause) pause.hidden = true;
      el.removeAttribute('data-lauf');
      return;
    }

    /* Endlos: Karten einmal klonen (für Screenreader und Tastatur unsichtbar) */
    var orig = Array.prototype.slice.call(spur.children);
    orig.forEach(function (li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); c.setAttribute('data-klon', '');
      c.querySelectorAll('a,button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      spur.appendChild(c);
    });
    function messen() { var a = spur.children[0], b = spur.children[orig.length]; halb = (a && b) ? b.offsetLeft - a.offsetLeft : 0; }
    messen();
    if (window.ResizeObserver) new ResizeObserver(messen).observe(spur);

    function laeuft() { var an = []; for (var k in gruende) if (gruende[k]) an.push(k); el.setAttribute('data-pause', an.join(' ')); return !an.length; }
    function tick(t) {
      raf = 0;
      if (!laeuft()) return;
      var dt = zuletzt ? Math.min(64, t - zuletzt) : 16; zuletzt = t;
      pos += tempo * dt / 1000;
      if (halb > 0 && pos >= halb) pos -= halb;
      fenster.scrollLeft = pos; gesetzt = fenster.scrollLeft;
      raf = requestAnimationFrame(tick);
    }
    function start() { if (!raf && laeuft()) { zuletzt = 0; pos = fenster.scrollLeft; raf = requestAnimationFrame(tick); } }
    function stopp() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }
    function anhalten(grund, ms) {
      gruende[grund] = true; stopp(); laeuft();
      if (ms) {
        clearTimeout(grund === 'touch' ? touchT : nutzerT);
        var t = setTimeout(function () { gruende[grund] = false; start(); }, ms);
        if (grund === 'touch') touchT = t; else nutzerT = t;
      }
    }
    function weiterlaufen(grund) { gruende[grund] = false; start(); }

    /* Eigenes Wischen/Scrollen erkennen: Position übernehmen, kurz anhalten, Endlos-Sprung */
    fenster.addEventListener('scroll', function () {
      var x = fenster.scrollLeft;
      if (Math.abs(x - gesetzt) > 3) {
        if (halb > 0 && x >= halb) { x -= halb; fenster.scrollLeft = x; }
        pos = x; gesetzt = x;
        if (laeuft() || gruende.nutzer) anhalten('nutzer', 5000);
      }
    }, { passive: true });

    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') anhalten('maus'); });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') weiterlaufen('maus'); });
    el.addEventListener('focusin', function () { anhalten('fokus'); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) weiterlaufen('fokus'); });
    fenster.addEventListener('touchstart', function () { anhalten('touch'); }, { passive: true });
    fenster.addEventListener('touchend', function () { anhalten('touch', 4000); }, { passive: true });
    fenster.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) anhalten('nutzer', 5000); }, { passive: true });

    if (pause) {
      pause.hidden = false;
      pause.addEventListener('click', function () {
        var an = pause.getAttribute('aria-pressed') === 'true';
        pause.setAttribute('aria-pressed', an ? 'false' : 'true');
        pause.setAttribute('aria-label', an ? 'Laufband anhalten' : 'Laufband starten');
        if (an) weiterlaufen('knopf'); else anhalten('knopf');
      });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) anhalten('versteckt'); else weiterlaufen('versteckt'); });
    if ('IntersectionObserver' in window) {
      gruende.sicht = true;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) weiterlaufen('sicht'); else anhalten('sicht'); });
      }, { threshold: 0.15 }).observe(el);
    } else start();
  }

  /* Kundenfoto groß */
  var dlg = null;
  function dialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'lr-sp-dialog';
    dlg.setAttribute('aria-label', 'Foto zur Bewertung');
    dlg.innerHTML = '<button type="button" class="lr-sp-dialog__zu" aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><img alt="" referrerpolicy="no-referrer"><p></p>';
    dlg.querySelector('button').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
    return dlg;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lr-sp-foto]');
    if (!b) return;
    var d = dialog(); if (typeof d.showModal !== 'function') { window.open(b.getAttribute('data-lr-sp-foto'), '_blank', 'noopener'); return; }
    var img = d.querySelector('img'); var klein = b.querySelector('img');
    img.src = b.getAttribute('data-lr-sp-foto');
    img.alt = klein ? klein.alt : 'Foto zur Bewertung';
    d.querySelector('p').textContent = klein ? klein.alt : '';
    d.showModal();
  });

  function alle(root) { (root || document).querySelectorAll('[data-lr-sp-reihe]').forEach(Reihe); }
  window.__lrSp = { alle: alle };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { alle(document); }); else alle(document);
  document.addEventListener('shopify:section:load', function (e) { alle(e.target); });
})();
